import axios from 'axios';
import { setAxiosRequestTokenInterceptor } from '../common/setAxiosRequestTokenInterceptor';
import { setAxiosResponseInterceptor } from './setAxiosResponseInterceptor';

export const deviceAxiosClient = axios.create();

setAxiosRequestTokenInterceptor(deviceAxiosClient);
setAxiosResponseInterceptor(deviceAxiosClient);
